const CONTACT_DATA={
    need_help_heading:"Need Help with Money Transfers? Let’s Make It Easy!",
    need_help_list:[
        "✔ Best exchange rates & fee comparisons",
        "✔ Choosing a secure remittance provider",
        "✔ Troubleshooting transfer issues",
        "✔ Sharing reviews & feedback",
        "✔ Partnering with us for fintech growth",
    ],
    compare:"Find the Best Remittance Provider – Compare & Save!",
    compare_list:[
        "Want to save money on international transfers?",
        "Looking for fast and low-cost money transfer services?",
        "Use Money Rate Finder to compare providers and get the best rates instantly!",
    ],
    experience_heading:"Share Your Experience & Help Others",
    experience_list:[
        "Used a remittance service? Leave a review!",
        "Your feedback helps users avoid hidden fees and find the most reliable providers."
    ],
    growth_heading:"Business Growth – Partner with Us!",
    growth_list:[
        "Are you a cross-border payments provider or fintech company?",
        "Feature your brand, explore advertising options, and share industry insights with our audience."
    ],
    disclaimer_heading:"Money Rate Finder does NOT process transactions.",
    disclaimer_list:[
        "We do not handle funds, store financial data, or track customer transfers.",
        "If you face an issue with a transfer, please contact your remittance provider directly."
    ],
}

export default CONTACT_DATA;